@if (userDetails()) {
  <div class="flex flex-col gap-6">
    <app-admin-panel-user-data-section
      sectionTitle="Dane osobowe"
      [fields]="personalSectionFields()"
    ></app-admin-panel-user-data-section>

    <app-admin-panel-user-data-section
      sectionTitle="Dane kontaktowe"
      [fields]="contactSectionFields()"
    ></app-admin-panel-user-data-section>

    <app-admin-panel-user-data-section
      sectionTitle="Konto i bezpieczeństwo"
      [fields]="securitySectionFields()"
    ></app-admin-panel-user-data-section>

    <app-admin-panel-user-logins-table
      [userDetails]="userDetailsInput()"
    ></app-admin-panel-user-logins-table>

    <app-admin-panel-user-organizations-table
      [userDetails]="userDetailsInput()"
    ></app-admin-panel-user-organizations-table>

    <div class="flex flex-wrap justify-end gap-2 md:gap-3">
      <p-button
        [label]="adminRoleActionLabel"
        styleClass="customInfoButton outlined"
        (click)="openSystemAdminRoleDialog()"
      />
      <p-button
        [label]="accountActionLabel"
        styleClass="customInfoButton outlined"
        (click)="openAccountLockDialog()"
      />
      <p-button
        label="Wstecz"
        styleClass="customInfoButton outlined"
        (click)="goBack()"
      />
    </div>
  </div>
}
